import { Award, Trophy, Users, Star, ClipboardList, Apple, Video, Brain } from "lucide-react";

const achievements = [
  {
    icon: Award,
    title: "DFB B-Lizenz",
    description: "Offiziell lizenzierter Trainer",
  },
  {
    icon: Trophy,
    title: "Westfalenliga",
    description: "Als Spieler aktiv",
  },
  {
    icon: Users,
    title: "Jugend & Herren",
    description: "Erfahrung auf allen Ebenen",
  },
  {
    icon: Star,
    title: "Profi-Mentoren",
    description: "Gelernt von den Besten",
  },
];

const specialServices = [
  {
    icon: ClipboardList,
    title: "Persönliche Trainingspläne",
    description: "Individuell auf dich abgestimmt",
  },
  {
    icon: Apple,
    title: "Ernährungs- & Fitnessberatung",
    description: "Ganzheitliche Betreuung",
  },
  {
    icon: Video,
    title: "Professionelle Videoanalyse",
    description: "Dein Spiel unter der Lupe",
  },
  {
    icon: Brain,
    title: "Mentales Training",
    description: "Selbstbewusstsein aufbauen",
  },
];

const mentors = [
  { name: "Irfan Buz", role: "Profi-Trainer" },
  { name: "Ingo Peters", role: "Profi-Trainer" },
  { name: "Nuri Sahin", role: "Profi-Spieler & Trainer" },
];

export const TrainerSection = () => {
  return (
    <section
      id="trainer"
      className="trainer-section py-20 lg:py-32"
      data-testid="trainer-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Image Column */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden border border-white/10">
                <img
                  src="https://customer-assets-m6fa6gv7.emergentagent.net/job_coach-reserve-2/artifacts/ca6c97a2a9709ae8_Socca%20World%20Cup%20am%20Spielfeldrand.png"
                  alt="Yasin Aktas - Personal Fußballtrainer beim Socca World Cup"
                  className="w-full h-full object-cover object-top trainer-image"
                  data-testid="trainer-image"
                />
              </div>
              
              {/* Floating Badge */}
              <div className="absolute -bottom-6 -right-6 bg-[#c1ff72] p-6 hidden sm:block">
                <p className="font-['Bebas_Neue'] text-3xl text-[#1A1A1A]">10+</p>
                <p className="text-[#1A1A1A]/70 text-sm">Jahre Erfahrung</p>
              </div>
            </div>
          </div>

          {/* Content Column */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <p className="text-xs uppercase tracking-[0.2em] text-[#c1ff72] font-semibold mb-4">
              Dein Trainer
            </p>
            
            <h2 className="font-['Bebas_Neue'] text-4xl md:text-6xl lg:text-7xl uppercase tracking-tighter text-white mb-2">
              DEIN TRAINER FÜR <span className="text-[#c1ff72]">ECHTE FORTSCHRITTE</span>
            </h2>
            <p className="text-[#71717A] mb-6">Yasin Aktas • 37 Jahre • aus Meinerzhagen</p>
            
            <p className="text-lg text-[#A1A1AA] leading-relaxed mb-4">
              <span className="text-white font-medium">Ich bin Yasin Aktas und unterstütze Spieler dabei, ihre Technik gezielt zu verbessern und mit mehr Selbstvertrauen auf dem Platz zu stehen.</span>
            </p>
            
            <p className="text-lg text-[#A1A1AA] leading-relaxed mb-4">
              Für mich ist es wichtig, Spieler individuell zu fördern und sie auf ihrem Weg langfristig zu begleiten. Jeder Spieler bekommt genau die Inhalte, die er braucht, um sich sichtbar zu verbessern.
            </p>

            <p className="text-lg text-[#A1A1AA] leading-relaxed mb-4">
              Als Inhaber der DFB B-Lizenz bringe ich jahrelange Erfahrung sowohl als Spieler als auch als Trainer mit. Meine Spielerkarriere bis zur Westfalenliga sowie die Zusammenarbeit mit Trainern wie Irfan Buz, Ingo Peters und Nuri Sahin haben mir wertvolles Wissen vermittelt, das ich heute direkt an meine Spieler weitergebe.
            </p>

            <p className="text-lg text-[#A1A1AA] leading-relaxed mb-4">
              <span className="text-white font-medium">Viele Spieler machen bereits nach wenigen Einheiten deutliche Fortschritte</span> – genau das ist mein Anspruch an jedes Training.
            </p>

            <p className="text-lg text-[#A1A1AA] leading-relaxed mb-8">
              Egal ob Anfänger oder ambitionierter Spieler: <span className="text-[#c1ff72] font-medium">Mein Ziel ist es, dich auf das nächste Level zu bringen.</span>
            </p>

            {/* Experience Grid */}
            <div className="grid grid-cols-2 gap-4 mb-10" data-testid="trainer-achievements">
              {achievements.map((item) => (
                <div
                  key={item.title}
                  className="bg-[#1A1A1A] border border-white/5 p-4 hover:border-[#c1ff72]/30 transition-colors duration-300"
                  data-testid={`achievement-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <item.icon className="w-5 h-5 text-[#c1ff72] mb-3" />
                  <h4 className="font-['Bebas_Neue'] text-xl text-white mb-1">
                    {item.title}
                  </h4>
                  <p className="text-[#71717A] text-sm">{item.description}</p>
                </div>
              ))}
            </div>

            {/* Coaching Experience */}
            <div className="mb-8">
              <h4 className="font-['Bebas_Neue'] text-xl text-white mb-4">
                TRAINER-ERFAHRUNG
              </h4>
              <div className="flex flex-wrap gap-3">
                <span className="px-4 py-2 bg-[#1A1A1A] border border-white/10 text-[#A1A1AA] text-sm">
                  Jugend bis Westfalenliga
                </span>
                <span className="px-4 py-2 bg-[#1A1A1A] border border-white/10 text-[#A1A1AA] text-sm">
                  Herren bis Bezirksliga
                </span>
              </div>
            </div>

            {/* Mentors */}
            <div>
              <h4 className="font-['Bebas_Neue'] text-xl text-white mb-4">
                GELERNT VON PROFIS
              </h4>
              <div className="flex flex-wrap gap-4" data-testid="trainer-mentors">
                {mentors.map((mentor) => (
                  <div
                    key={mentor.name}
                    className="flex items-center gap-3 bg-[#1A1A1A] border border-white/5 px-4 py-3"
                  >
                    <div className="w-8 h-8 bg-[#c1ff72]/20 rounded-full flex items-center justify-center">
                      <span className="text-[#c1ff72] text-sm font-semibold">
                        {mentor.name[0]}
                      </span>
                    </div>
                    <div>
                      <p className="text-white text-sm font-medium">{mentor.name}</p>
                      <p className="text-[#71717A] text-xs">{mentor.role}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Special Services Section */}
        <div className="mt-20 pt-16 border-t border-white/5">
          <div className="text-center mb-12">
            <p className="text-xs uppercase tracking-[0.2em] text-[#c1ff72] font-semibold mb-4">
              Mein Ansatz
            </p>
            <h3 className="font-['Bebas_Neue'] text-3xl md:text-5xl uppercase tracking-tighter text-white">
              GANZHEITLICHE <span className="text-[#c1ff72]">SPIELERENTWICKLUNG</span>
            </h3>
            <p className="text-[#A1A1AA] mt-4 max-w-2xl mx-auto">
              Technik, Athletik, Taktik und mentale Stärke – ich begleite dich auf deinem kompletten Weg zum Erfolg.
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="special-services">
            {specialServices.map((service) => (
              <div
                key={service.title}
                className="bg-[#1A1A1A] border border-white/5 p-6 hover:border-[#c1ff72]/50 transition-all duration-300 group"
                data-testid={`special-service-${service.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="w-12 h-12 bg-[#c1ff72]/10 flex items-center justify-center mb-4 group-hover:bg-[#c1ff72]/20 transition-colors duration-300">
                  <service.icon className="w-6 h-6 text-[#c1ff72]" />
                </div>
                <h4 className="font-['Bebas_Neue'] text-xl text-white mb-2">
                  {service.title}
                </h4>
                <p className="text-[#71717A] text-sm">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainerSection;
